import React, { memo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { countdownNumberVariants, fightTextVariants } from '../animations/variants';
import { UI_STRINGS } from '../strings/uiStrings';

interface CountdownOverlayProps {
  value: number; // 3, 2, 1, or 0 (= FIGHT!)
}

/**
 * Full-arena countdown overlay — renders 3, 2, 1, then "FIGHT!".
 * Positioned absolutely over the arena; does not block the egg background.
 */
function CountdownOverlayComponent({ value }: CountdownOverlayProps): React.ReactElement {
  const isFight = value === 0;

  return (
    <div
      className="absolute inset-0 flex items-center justify-center pointer-events-none"
      style={{ zIndex: 40 }}
    >
      <AnimatePresence mode="wait">
        {isFight ? (
          <motion.div
            key="fight"
            variants={fightTextVariants}
            initial="enter"
            animate="visible"
            exit="exit"
            style={{
              willChange: 'transform, opacity',
              fontFamily: 'var(--font-game)',
              fontSize: '7rem',
              fontWeight: 900,
              fontStyle: 'italic',
              color: '#ff2424',
              lineHeight: 1,
              textShadow:
                '0 0 40px rgba(255,36,36,0.8), 0 0 80px rgba(255,36,36,0.4), 0 4px 12px rgba(0,0,0,0.9)',
              letterSpacing: '-0.02em',
              userSelect: 'none',
            }}
          >
            {UI_STRINGS.countdown.fight}
          </motion.div>
        ) : (
          <motion.div
            key={value}
            variants={countdownNumberVariants}
            initial="enter"
            animate="visible"
            exit="exit"
            style={{
              willChange: 'transform, opacity',
              fontFamily: 'var(--font-game)',
              fontSize: '9rem',
              fontWeight: 900,
              fontStyle: 'italic',
              color: 'white',
              lineHeight: 1,
              textShadow:
                '0 0 30px rgba(255,255,255,0.5), 0 4px 20px rgba(0,0,0,0.9)',
              letterSpacing: '-0.04em',
              userSelect: 'none',
            }}
          >
            {value}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export const CountdownOverlay = memo(CountdownOverlayComponent);
